import { fromPromise } from "xstate";

import {
  getFacilityLocations,
  type FacilityLocation,
  type GetFacilityLocationsParams,
} from "@/lib/services/getFacilityLocations";

export const getFacilityLocationsActor = fromPromise<
  FacilityLocation[],
  GetFacilityLocationsParams
>(async ({ input }) => getFacilityLocations(input));
